<template>
    <a href="#" role="button" :aria-label="label" :title="label"
        class="downloaderGalleryLink py-1 px-4 rounded flex justify-center border cursor-pointer"
        @click.prevent="$emit('click')">
        <span class="material-icons">
            {{ icon }}
        </span>
    </a>
</template>

<script>
export default {
    name: "ActionIconButton",

    props: {
        icon: { type: String, required: true },
        label: { type: String, required: true }
    }
};
</script>
